import { Category } from 'panel/category/redux/types'
import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

import { PaginationOpts } from 'util/types/index'

export interface Product {
  id: number,
  isActive: boolean,
  isSellable: boolean,
  category: Category,
  name: string,
  description?: string,
  pictureTiny: string,
  pictureSmall: string,
  pictureMedium: string,
  pictureLarge: string,
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface ProductState {
  readonly product?: Product
  readonly productList: { items: Partial<Product>[], pagination?: PaginationOpts }
}

/**
* Action Enum Types
*/

export enum ProductTypes {
  PRODUCT_CREATE = 'PRODUCT/LOCAL/CREATE',
  PRODUCT_UPDATE = 'PRODUCT/LOCAL/UPDATE',
  PRODUCT_DELETE = 'PRODUCT/LOCAL/DELETE',
  PRODUCT_GET = 'PRODUCT/LOCAL/GET',
  PRODUCT_LIST = 'PRODUCT/LOCAL/LIST'
}

/**
* Action Types
*/
interface CreateProduct {
  type: typeof ProductTypes.PRODUCT_CREATE,
  payload: Product
}

interface UpdateProduct {
  type: typeof ProductTypes.PRODUCT_UPDATE,
  payload: Product
}

interface DeleteProduct {
  type: typeof ProductTypes.PRODUCT_DELETE,
  payload: number
}

interface GetProduct {
  type: typeof ProductTypes.PRODUCT_GET,
  payload: Product
}

interface GetProductList {
  type: typeof ProductTypes.PRODUCT_LIST,
  payload: Partial<Product>[]
  pagination?: PaginationOpts
}

export type ProductActionTypes = (
  AlertActionTypes | CreateProduct | UpdateProduct | DeleteProduct | GetProduct | GetProductList
)
